import { withProcedureWraper } from "../../../../..";
import ProcedureLayout from "../../../../../../../components/layouts/procedure-layout";
import { CreateApplicationForTerminationContractForm } from "../../../../absence-letter/components/create-application-for-termination-contract-form";
export const TerminationContractCreateTSN = withProcedureWraper(() => {
  return (
    <ProcedureLayout title="Tạo đơn xin chấm dứt HĐLĐ">
      <CreateApplicationForTerminationContractForm />
    </ProcedureLayout>
  );
});
